import React, { useEffect, useRef, useState } from "react";
import { Button, Radio } from "antd"
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { FaRegClock } from '@react-icons/all-files/fa/FaRegClock';
import "./index.scss"
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { FaDownload } from '@react-icons/all-files/fa/FaDownload'
import { reportEvent } from "../../../../services/analyticsService";
import { isMobile } from "../../../../services/clientService";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { ResumePrint } from "../../../../components/pdf/ResumePrint";

const ResumeBuilderHeader = props => {
    const { didCompleteWizard, profileReport, mode, resumeId, setSignupModalOpen, resume } = props;
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [emojiBump, setEmojiBump] = useState(false);
    const prevScore = useRef(profileReport?.totalScore);
    const dispatch = useDispatch()
    const hasActiveSubscription = 
     userDetails?.subscription?.active;
    useEffect(() => {
        if (
            typeof profileReport?.totalScore === "number" &&
            profileReport.totalScore !== prevScore.current
        ) {
            setEmojiBump(true);
            setTimeout(() => setEmojiBump(false), 500); // 0.5s
        }
        prevScore.current = profileReport?.totalScore;
    }, [profileReport?.totalScore]);

    const getEmoji = (score) => {
        if (score >= 60) return "😍";
        if (score >= 30) return "😊";
        return "🤔";
    };
    const onActionButtonClick = (e) => {
        const { value } = e.target;
        if (value === 'form') {
            dispatch(push(`/resume-builder/${resumeId}/personal`))
        }
        else if (value === 'improve') {
            dispatch(push(`/resume-builder/${resumeId}/improve`))
        }
        else if (value === 'design') {
            dispatch(push(`/resume-builder/${resumeId}/design`))
        }
    }

    const onDownloadClick = () => {
        reportEvent('resume_builder', 'download_click', { source: 'design' })
        if (userDetails) {
            if (hasActiveSubscription) {
                // TODO: Implement download for paid users
            }
            else {
                props.setPurchaseModalOpen(true)
                reportEvent('resume_builder', 'download_upgrade_click', { source: 'template_click' })
            }
        }
        else {
            setSignupModalOpen(true)
        }
    }

    const getBarColor = (score) => {
        if (score >= 60) return "#52c41a"; // green
        return "#ffa940"; // orange
    };
    const generateFileName = () => {
        let names = [resume?.firstName, resume?.lastName].filter(i => !!i).join(' ').toLowerCase().replace(/ /g, '_');
        if (!names) {
            return 'Profile.pdf'
        }
        return `${names}_resume.pdf`;
    }
    return (
        <div className="resume-builder-header">
            <div className="left">
                {(!didCompleteWizard && mode === 'form') && <Button disabled={!didCompleteWizard}>
                    <FaEdit />
                    Write
                </Button>}
                {(didCompleteWizard || ['design', 'improve'].includes(mode)) && <Radio.Group value={mode} onChange={onActionButtonClick} optionType="button" buttonStyle="solid" className="left-buttons"
                    options={[{
                        label: <>
                            Write
                        </>, value: 'form'
                    }, { label: 'Design', value: 'design' }, { label: 'Improve', value: 'improve' }]} />}

                <div className="progress-bar-card">
                    <span
                        className={`progress-bar-emoji${emojiBump ? ' bump' : ''}`}
                        role="img"
                        aria-label="progress"
                    >
                        {getEmoji(profileReport?.totalScore || 0)}
                    </span>
                    <div className="progress-bar-bg">
                        <div
                            className="progress-bar-fill"
                            style={{ width: `${profileReport?.totalScore || 0}%`, background: getBarColor(profileReport?.totalScore || 0) }}
                        />
                    </div>
                    <span className="progress-bar-label">{profileReport?.totalScore || 0}%</span>
                </div>
                {mode === 'form' && !didCompleteWizard && <div className="resume-banner">
                    <div className="banner-icon">
                        <FaRegClock size={32} />
                    </div>
                    <div className="banner-text">
                        <div className="banner-title">Job winning resume in 15 minutes</div>
                        <div className="banner-subtitle">Forget writers block with our AI assistant</div>
                    </div>
                </div>}
            </div>
            <div className="right">
                {didCompleteWizard && hasActiveSubscription && <PDFDownloadLink document={<ResumePrint resume={resume} />} fileName={generateFileName()}>
                    {({ blob, url, loading, error }) => (loading ? null : <Button className="download-btn" >
                        {isMobile() ? '' : 'Download'} <FaDownload />
                    </Button>)}
                </PDFDownloadLink>}
                {!hasActiveSubscription && (props.didCompleteWizard || ['design', 'improve'].includes(mode)) && <Button className="download-btn" onClick={onDownloadClick}>
                    {isMobile() ? '' : 'Download'} <FaDownload />
                </Button>}
            </div>
        </div>
    )
}

export default ResumeBuilderHeader